<template>
    <div>
        <NewItem ref="addNewTemplateDialog" @saveSuccess="loadData"></NewItem>
        <input :key="getFileInputKey" type="file" @change="getFile" :accept="acceptList" ref="filePicker" style="display: none;"/>
        <el-row style="width:100%; padding:15px;">
            <el-col :span="16">
                <el-form ref="form" label-width="120px">
                    <el-form-item label="输入流程号">
                        <el-input v-model="search" style="width:200px;"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="8">
                <el-button @click="loadData" type="primary">查询</el-button>
                <el-button @click="newItem" type="primary">新增</el-button>
                <el-button @click="$refs.filePicker.click()" type="primary">导入</el-button>
                <el-button @click="exportExcel" type="primary">导出</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" style="width: 100%; min-height:450px;">
            <el-table-column prop="name" label="流程号" width="150"></el-table-column>
            <el-table-column prop="deviceName" label="设备"></el-table-column>
            <el-table-column prop="remark" label="备注" width="250"></el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="deleteItem(scope.row)" type="primary">删除</el-button>
                    <el-button @click="updateItem(scope.row)" type="primary">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <center>
            <el-pagination
                @prev-click="prePage"
                @next-click="nextPage"
                @current-change="pageChange"
                :page-size="pageSize"
                :pager-count="10"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </center>
    </div>
</template>
<script>
import NewItem from './NewItem';
import XLSX from 'xlsx'
import toExcel from '../../../../components/js/toExcel';

export default {
    components:{
        NewItem
    },
    data(){
        return{
            pageIndex:0,
            pageSize:10,
            pageCount:0,
            total:0,
            tableData: [],
            search: '',
            acceptList: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
            getFileInputKey:0,//用于让input在选中文件后重置
            excelData: [
                {
                    name: '张三',
                    birthday: new Date('1990-01-01'),
                    sex: '男',
                    age: 28
                },
                {
                    name: '李四',
                    birthday: new Date('1991-01-01'),
                    sex: '女',
                    age: 27
                }
            ]

        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        newItem(){
            this.$refs.addNewTemplateDialog.title="新增皮带流程"

            this.$refs.addNewTemplateDialog.id = -1;
            this.$refs.addNewTemplateDialog.name = '';
            this.$refs.addNewTemplateDialog.remark = '';
            this.$refs.addNewTemplateDialog.addTemplateShow=true
            setTimeout(function(){
                this.$refs.addNewTemplateDialog.cleanTree();
            }.bind(this),500)
        },
        updateItem(item){
            this.$refs.addNewTemplateDialog.title="编辑皮带流程"
            this.$refs.addNewTemplateDialog.id = item.id;
            this.$refs.addNewTemplateDialog.name = item.name;
            this.$refs.addNewTemplateDialog.remark = item.remark;
            var dl = [];
            var arr = item.deviceName.split(',');
            for(var i=0; i<arr.length; i++){
                if(arr[i] == ','){
                    continue;
                }
                dl.push({label:arr[i]});
            }
            this.$refs.addNewTemplateDialog.selectDeviceList = dl;
            this.$refs.addNewTemplateDialog.addTemplateShow=true
            setTimeout(function(){
                this.$refs.addNewTemplateDialog.cleanTree();
            }.bind(this),500)
            setTimeout(function(){
                this.$refs.addNewTemplateDialog.setSelectedDeviceTree(item.deviceNo)
            }.bind(this),1000)
            
            //设置设备数据
        },
        deleteItem(item){
            console.log(item)
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.deleteItemImpl(item.id);
            })
        },
        deleteItemImpl(id){
            this.$api.ningboApi.delBelt(id, response => {
                this.loadData();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                })
        },
        loadData(){
            this.$api.ningboApi.findAllBelt(this.search, this.pageIndex, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        searchData(){
            this.pageIndex = 0;
            this.loadData();
        },
        prePage(){
            // console.log(this.pageIndex - 1)
            // this.$api.ningboApi.findAllBelt(this.search, this.pageIndex - 1, this.pageSize, response => {
            //     this.refreshData(response);
            // })
        },
        nextPage(){
            // console.log(this.pageIndex + 1)
            // this.$api.ningboApi.findAllBelt(this.search, this.pageIndex + 1, this.pageSize, response => {
            //     this.refreshData(response);
            // })
        },
        pageChange(page){
            page = page - 1;
            this.$api.ningboApi.findAllBelt(this.search, page, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        refreshData(data){
            console.log(data)
            this.pageIndex = data.data.pageIndex;
            this.pageSize = data.data.pageSize;
            this.pageCount = data.data.pageCount;
            this.total = data.data.total;
            this.tableData = data.data.list;
        },
        getFile(event) {
            //清除选中
            this.getFileInputKey++
            var that = this;
            const files = event.target.files;
            if(files.length<=0){//如果没有文件名
                return false;
            }else if(!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())){
                this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        type: 'binary'
                    });
                    const wsname = workbook.SheetNames[0];//取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
                    var outputs = [];//清空接收数据
                    //编辑数据
                    for(var i= 0;i<ws.length;i++){
                        var deviceNo = ws[i].流程设备;
                        if(ws[i]['__EMPTY']){
                            deviceNo += ',' + ws[i]['__EMPTY'];
                        }
                        for(var j=1; j<100; j++){
                            var td = ws[i]['__EMPTY_' + j]
                            if(td){
                                deviceNo += ',' + td;
                            }
                        }
                        var sheetData = {
                            orderid: ws[i].序号,
                            name: ws[i].流程号,
                            deviceNo: deviceNo
                        }
                        outputs.push(sheetData);
                    }
                    this.importData(outputs)
                } catch (e) {
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },
        importData(belts){
            this.$api.ningboApi.importBelts(JSON.stringify(belts), response => {
                this.loadData();
                this.$message({
                    type: 'success',
                    message: '导入成功'
                });
            }, failure => {
                this.$message({
                    type: 'error',
                    message: failure
                });
            })
        },
        exportExcel() {
            this.$api.ningboApi.findAllBelt(this.search, -1, -1, response => {
                const th = ['序号', '流程号', '流程设备', '设备No']
                const filterVal = ['orderid', 'name', 'deviceName', 'deviceNo']
                const data = response.data.list.map(v => filterVal.map(k => v[k]))
                const [fileName, fileType, sheetName] = ['皮带流程', 'xlsx', 'sheet1']
                toExcel({th, data, fileName, fileType, sheetName})
            })
        }
    }
}
</script>